import { render, staticRenderFns } from "./ContentBlockCodeBlock.vue?vue&type=template&id=0a0b6c3b&"
import script from "./ContentBlockCodeBlock.vue?vue&type=script&lang=js&"
export * from "./ContentBlockCodeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports